import {Component, Input, OnChanges} from '@angular/core';
import {NbDialogService} from '@nebular/theme';
import {Router} from '@angular/router';
import {InvoicingService} from '../../shared/invoicing.service';
import {InvoiceSummary} from '../../interfaces/invoicing';
import {NewInvoiceDialogComponent} from '../new-invoice-dialog/new-invoice-dialog.component';
import {TranslateService} from '@ngx-translate/core';

/** A project's invoices, newest first, and a new draft from its approved hours and trips (#1518). */
@Component({
  selector: 'bst-project-invoices',
  templateUrl: './project-invoices.component.html',
  styles: [`
    table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
    th, td { padding: 6px 8px; text-align: left; border-bottom: 1px solid var(--border-basic-color-3); }
    th { font-weight: 600; color: var(--text-hint-color); }
    .num { text-align: right; white-space: nowrap; }
    tr.link { cursor: pointer; }
    tr.link:hover td { background: var(--background-basic-color-2); }
    .muted { color: var(--text-hint-color); }
    .actions { display: flex; justify-content: flex-end; margin-top: 12px; }
  `],
  standalone: false
})
export class ProjectInvoicesComponent implements OnChanges {
  @Input() projectId: number;
  @Input() projectName: string;
  invoices: InvoiceSummary[] = null;

  constructor(private invoicing: InvoicingService, private dialogs: NbDialogService, private router: Router,
              private translate: TranslateService) {}

  // The UI language, passed to the currency pipe: LOCALE_ID is fixed at bootstrap.
  get lang(): string {
    return this.translate.currentLang ?? this.translate.defaultLang;
  }

  async ngOnChanges() {
    const id = this.projectId;
    this.invoices = null;
    const invoices = await this.invoicing.getInvoices(id).catch(() => []);
    if (id === this.projectId) { this.invoices = invoices; }
  }

  create() {
    this.dialogs.open(NewInvoiceDialogComponent, {context: {projectId: this.projectId, projectName: this.projectName}});
  }

  open(invoice: InvoiceSummary) {
    this.router.navigate(['/invoices', invoice.id]);
  }
}
